import * as React from 'react';
import * as mrCap from '../../mrCapTypes';
import { className, formatNumber } from '../../util';
import { PageIntro } from '../pageintro';
import { Portal } from '../portal';
import * as gtm from '../../gtm';
import { globalStrings } from '../index';

interface ProductProps {
  campaign?: mrCap.CampaignResponse;
  product: mrCap.Product;
  selected: boolean;
  disabled: boolean;
  visible: boolean;
  vehicle?: mrCap.VehicleInfo;
  showReadmore?: boolean;
  upsellProduct?: mrCap.Product | null;
  downsellProduct?: mrCap.Product | null;
  toggle: (product: mrCap.Product) => void;
  updateSelectedProduct: (artNr: string, noi: number) => void;
  showLinkedReadmore: (artNr: string) => void;
}

interface ProductState {
  readmore: boolean;
  amount: number;
}

export class Product extends React.Component<ProductProps, ProductState> {

  constructor(props: ProductProps) {
    super(props);

    this.state = {
      readmore: props.showReadmore ?? false,
      amount: this.props.product.noi
    };
  }

  componentDidUpdate(prevProps: ProductProps) {
    if (prevProps.showReadmore && !this.state.readmore) {
      this.setState({ readmore: true });
    }
  }

  handleToggle = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    let updatedProduct = this.props.product;

    if (updatedProduct.noi !== this.state.amount) {
      updatedProduct.noi = this.state.amount;
    }

    if (!this.props.disabled) {
      this.props.toggle(updatedProduct);
    }

  };

  AmountHandler = () => {
    return(
      <div className='amount-choice'>
        <div className='amount-centerer'>
          <div className='amountUp' onClick={() => this.setState({
            amount: this.state.amount + 1 },
          () => this.props.updateSelectedProduct(this.props.product.articleNr, this.state.amount))}>
            <span><i className='fas fa-chevron-up'></i></span>
          </div>

          <div className='amount-count'>{this.state.amount}</div>

          <div className={className('amountDown', {disabled: this.state.amount === 1})} onClick={() => this.setState({
            amount: this.state.amount > 1
              ? this.state.amount - 1
              : this.state.amount },
          () => this.props.updateSelectedProduct(this.props.product.articleNr, this.state.amount))}>
            <span><i className='fas fa-chevron-down'></i></span>
          </div>
        </div>
      </div>
    );
  };

  ToggleButton = ({selected, amount}: {selected: boolean; amount: number}) => {
    return(
      <div
        className={className('product-choose cta-btn primary', { disabled: this.props.disabled })}
        onClick={this.handleToggle}>

        {selected
          ? <span>{amount > 1 ? `${amount} valda` : 'Vald' } <i className="fas fa-check"></i></span>
          : <span>Välj</span>}
      </div>
    );
  };

  render() {

    const { product, selected, disabled, visible, vehicle } = this.props;
    const isCampaign = (product.salePriceVehicle ?? 0) > 0 && (product.discount ?? 0) > 0;
    const price = vehicle
      ? product.salePriceVehicle ?? product.priceVehicle
      : product.priceNew || product.priceBase;

    return (
      <div className={className('product-box', { visible })}>
        <div className={className('product', { selected, disabled })}>
          <div className='product-image'
            style={{backgroundImage: 'url(/gen.img?imgurl=/' + product.productImgUrl + '&mw=400)'}}></div>

          <div className='product-title'><h3>{product.title}</h3></div>

          <div className='product-desc'>
            {product.descShort}</div>

          <div className='product-price second'>
            {price === 0 ?
              <span>{globalStrings.zeroPrice}</span>
              : <>

                {(product.type === mrCap.ArticleType.treatment) &&
                  <span className='price-label'>Från</span>}

                {formatNumber(price)}
                {isCampaign && <span className='price-old'>
                  {formatNumber(product.priceVehicle)}
                </span>}
                <span> SEK</span>
                {isCampaign && <span className='price-discount'>(-{product.discount} %)</span>}
              </>}
          </div>

          <div className='product-readmore cta-btn'
            onClick={() => {
              gtm.productDetail(gtm.convertProduct(product, this.props.campaign?.code), 'productReadMore');
              this.setState({readmore: true});
            }}>Läs mer</div>

          <this.ToggleButton selected={selected} amount={this.state.amount} />

          <Portal visible={this.state.readmore} onClose={() => this.setState({readmore: false})}>
            <div className='product-image'
              style={{backgroundImage: 'url(/gen.img?imgurl=/' + product.productImgUrl + '&mw=600)'}}></div>

            <PageIntro
              header={product.title}
              preamble={product.descLong}/>

            <div className='product-price-box'>
              {<div className='product-price second'>

                {(product.type === mrCap.ArticleType.treatment) &&
                  <span className='price-label'>Från</span>}

                <span className='price'>
                  {formatNumber(price)}
                  <span className='price-ending'> SEK</span>
                </span>

                {isCampaign && <span className='price-old'>
                  {formatNumber(product.priceVehicle)}
                  <span className='price-ending'> SEK</span>
                </span>}
              </div>}
            </div>

            <this.ToggleButton selected={selected} amount={this.state.amount} />

            <div className='product-choose-linked-container'>
              {this.props.downsellProduct && (
                <div className='product-choose cta-btn primary' onClick={e => {
                  e.preventDefault();

                  this.setState({ readmore: false }, () => {
                    this.props.showLinkedReadmore(this.props.downsellProduct!.articleNr);
                  });
                }}>
                  <span>&lt; {this.props.downsellProduct.title}</span>
                </div>
              )}

              {this.props.upsellProduct && (
                <div className='product-choose cta-btn primary' onClick={e => {
                  e.preventDefault();

                  this.setState({ readmore: false }, () => {
                    this.props.showLinkedReadmore(this.props.upsellProduct!.articleNr);
                  });
                }}>
                  <span>{this.props.upsellProduct.title} &gt;</span>
                </div>
              )}
            </div>

          </Portal>

        </div>

        {product.type === mrCap.ArticleType.product && <this.AmountHandler />}

      </div>
    );
  }
}